import {CoinsSections_Levels_Slider_Level} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/wallet/v1/page/sections.types';
import {COLORS, GenericIconName, IconName} from '@aboutyou/ui-components';

export const normalizeCoinsLevel = (
  level: CoinsSections_Levels_Slider_Level,
): {
  bonusDescription: string;
  bonusValue: string;
  bottomHint: string;
  color: keyof typeof COLORS | undefined;
  leftIcon: IconName | undefined;
  rightIcon: IconName | undefined;
  rightIconColor: keyof typeof COLORS | undefined;
} => {
  switch (level.type?.$case) {
    case 'claimed':
      return {
        ...level.type.claimed,
        color: 'Text.Grey',
        leftIcon: GenericIconName.CoinsDoubleColor,
        rightIcon: GenericIconName.AlertSuccessFill,
        rightIconColor: 'Alerts.Success.Primary',
      };
    case 'pending':
      return {
        ...level.type.pending,
        color: 'White',
        leftIcon: GenericIconName.CoinsStriped,
        rightIcon: GenericIconName.Clock,
        rightIconColor: 'White',
      };
    case 'notReached':
      return {
        ...level.type.notReached,
        color: 'Black',
        leftIcon: GenericIconName.CoinsDoubleColor,
        rightIcon: GenericIconName.Locked,
        rightIconColor: 'Fill.Grey.Inactive',
      };
    default:
      return {
        bonusValue: '',
        bonusDescription: '',
        bottomHint: '',
        color: undefined,
        leftIcon: undefined,
        rightIcon: undefined,
        rightIconColor: undefined,
      };
  }
};
